import {Component, EventEmitter, inject, OnInit, Output, signal} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {environment} from "projects/store/src/environments/environment";
import {LocalStorageKey, ExternalSite, SalesWorkflowSteps, SalesWorkflow} from "projects/store/src/app/enums";
import {CustomMessageService, LocalStorageService, UtilService, OriginMessageError} from "library";
import {RequestService} from "projects/store/src/app/services/api/v1/request.service";
import {HttpErrorResponse, HttpStatusCode} from "@angular/common/http";
import {SalesWorkflowService} from "projects/store/src/app/services/api/v1/sales-workflow.service";
import {MacroFlowService} from "projects/store/src/app/services/api/v1/macro-flow.service";


const SIM_CARD_UNLOCK_ERROR_MSG = 'No se pudo realizar el desbloqueo de la SIM Card. Por favor vuelve a intentarlo.';

@Component({
  selector: 'app-sales-final-message-general',
  templateUrl: './sales-final-message-general.component.html'
})
export class SalesFinalMessageGeneralComponent implements OnInit{
  private readonly route = inject(ActivatedRoute);
  private readonly utilService = inject(UtilService);
  private requestService = inject(RequestService);
  private customMessageService = inject(CustomMessageService);
  private readonly salesWorFlowService = inject(SalesWorkflowService);
  public  macroFlowService = inject(MacroFlowService);
  private router = inject(Router);

  private readonly request_id = this.route.snapshot.params['request_id'];
  readonly categoryCode = this.route.snapshot.params['category_code'];
  readonly flowCode = this.route.snapshot.params['flow_code'];
  routesBreadcrumb = ['VENTAS', 'Autogestión', 'Finalizado'];
  request = this.requestService.request;

  visibleErrorSIM: boolean = false;
  visibleSuccessSIM: boolean = false;
  visibleImportantMsg: boolean = false;
  data = signal<any>({});
  isLoading = signal<boolean>(false);
  statusText = signal<string | null>(null);
  stepByFlows: any = [];

  ngOnInit(): void {
    this.load();
  }


  load(){
    this.utilService.enablePageLoading();
    this.data.set(this.request);
    this.loadStepsByFlow();

    if(this.isFlowAddressSales){
      this.visibleImportantMsg = true;
    };
  }

  loadStepsByFlow(){
    this.salesWorFlowService.getStepsByFlowId(this.salesWorFlowService.workflow.id, this.requestService.categoryId).subscribe({
      next:(resp) => {
        if (resp.status === HttpStatusCode.Ok){
          this.stepByFlows = resp.body.data.list;
          this.showUnlockSimButton();
        }
        this.utilService.disablePageLoading();
      },
      error: (err: HttpErrorResponse)=> {
        this.utilService.disablePageLoading();
      }
    })
  }

  get isFlowAddressSales(): boolean {
    return this.flowCode === SalesWorkflow['domicilio-vendedor'];
  }

  showUnlockSimButton(): boolean{
    return this.stepByFlows.some( (item: { code: string; }) => item.code === SalesWorkflowSteps["phone-enrollment"] );
  }

  unlockSimCard(){
    this.isLoading.set(true);
    this.requestService.unlockSim(this.request_id).subscribe({
      next:(resp) => {
        if (resp.status == HttpStatusCode.Ok){
          this.visibleSuccessSIM = true;
        }else{
          this.customMessageService.responseNoticeHandler(resp);
        }
        this.isLoading.set(false);
      },
      error: (err: HttpErrorResponse)=> {
        if( err.status === HttpStatusCode.NotAcceptable ){
          this.customMessageService.responseNoticeHandler({...err, error: { ...err.error, message: SIM_CARD_UNLOCK_ERROR_MSG}}, OriginMessageError.BACKEND, { message: SIM_CARD_UNLOCK_ERROR_MSG});
        }else{
          this.customMessageService.responseNoticeHandler(err);
        }
        this.isLoading.set(false);
      }
    })

  }

  onHomePage() {
    if (this.flowCode === SalesWorkflow['claro-ecommerce']) {
      this.isLoading.set(true);
      this.requestService.getRequestAttributes(this.request_id, 'claro_e_commerce_data').subscribe({
        next: (resp) => {
          if (resp.status === HttpStatusCode.Ok) {
            const redirectionUrl = resp.body?.data?.value?.redirectionUrl;
            if (redirectionUrl) {
              window.location.href = redirectionUrl;
              return;
            }
          }
          this.customMessageService.responseNoticeHandler(resp);
          this.isLoading.set(false);
        },
        error: (err: HttpErrorResponse) => {
          this.customMessageService.responseNoticeHandler(err);
          this.isLoading.set(false);
        }
      });
      return;
    }

    this.salesWorFlowService.navigateToInitial(this.flowCode);
  }

  frequencyText(): string {
    return this.utilService.getFrequencyDescription(this.data().quotes?.frecuency);
  }

  hasAdditionalProduct(): boolean {
    return !!this.data()?.additional_product;
  }

  getAdditionalProduct(): any {
    return this.data()?.additional_product;
  }

  getAdditionalProductNetAmount(): number {
    const additionalProduct = this.getAdditionalProduct();
    if (!additionalProduct) {
      return 0;
    }

    if (additionalProduct.net_amount !== undefined && additionalProduct.net_amount !== null) {
      return Number(additionalProduct.net_amount) || 0;
    }

    const amount = Number(additionalProduct.amount) || 0;
    const discountPct = Number(additionalProduct.discount_pct) || 0;
    return amount * (1 - discountPct / 100);
  }

  getProductsSubtotal(): number {
    return Number(this.data()?.quotes?.prices?.selected) || 0;
  }

  getMainProductAmount(): number {
    const selectedPrice = this.getProductsSubtotal();
    if (!this.hasAdditionalProduct()) {
      return selectedPrice;
    }

    return selectedPrice - this.getAdditionalProductNetAmount();
  }

  getInstallmentAmount(): number {
    return Number(this.data()?.quotes?.installment?.selected) || 0;
  }

  getFinancedTotalAmount(): number {
    return this.getProductsSubtotal() - this.getInstallmentAmount();
  }

}
